import qs from 'qs';
import request from '../index';

// 上传文件
export const uploadInspectionAttachment = (data) => request.post('api-qc/uploadInspectionAttachment', data, {
    timeout: 1800000,
});

// 获取PQC三大件列表
export const getPQCThreeMajorItemsList = (params) => request.get('api-qc/getPQCThreeMajorItemsList', { params });

// 获得PQC三大件合格情况
export const getPQCThreeMajorItemsEligibility = (params) => request.get('api-qc/getPQCThreeMajorItemsEligibility', { params });

// 添加或更新PQC三大件
export const saveOrUpdatePQCThreeMajorItems = (data) => request.post('/api-qc/saveOrUpdatePQCThreeMajorItems', data);

// 获得PQC参考臂列表
export const getPQCReferenceArmList = (params) => request.get('api-qc/getPQCReferenceArmList', { params });

// 获得PQC参考臂合格情况
export const getPQCReferenceArmEligibility = (params) => request.get('api-qc/getPQCReferenceArmEligibility', { params });

// 添加或更新PQC参考臂
export const saveOrUpdatePQCReferenceArm = (data) => request.post('/api-qc/saveOrUpdatePQCReferenceArm', data);

// 获取PQC完整参考臂列表
export const getPQCCompleteReferenceArmList = (params) => request.get('api-qc/getPQCCompleteReferenceArmList', { params });

// 获得PQC完整参考臂情况
export const getPQCCompleteReferenceArmEligibility = (params) => request.get('api-qc/getPQCCompleteReferenceArmEligibility', { params });

// 添加或更新PQC完整参考臂
export const saveOrUpdatePQCCompleteReferenceArm = (data) => request.post('/api-qc/saveOrUpdatePQCCompleteReferenceArm', data);

// 获取PQC定标列表
export const getPQCCalibrateList = (params) => request.get('api-qc/getPQCCalibrateList', { params });

// 获得PQC定标情况
export const getPQCCalibrateEligibility = (params) => request.get('api-qc/getPQCCalibrateEligibility', { params });

// 添加或更新PQC定标
export const saveOrUpdatePQCCalibrate = (data) => request.post('/api-qc/saveOrUpdatePQCCalibrate', data);

// 获取PQC总装调试列表
export const getPQCAssembleDebugList = (params) => request.get('api-qc/getPQCAssembleDebugList', { params });

// 获得PQC总装调试情况
export const getPQCAssembleDebugEligibility = (params) => request.get('api-qc/getPQCAssembleDebugEligibility', { params });

// 添加或更新PQC总装调试
export const saveOrUpdatePQCAssembleDebug = (data) => request.post('/api-qc/saveOrUpdatePQCAssembleDebug', data);

// 添加或更新OQC
export const saveOrUpdateOQC = (data) => request.post('/api-qc/saveOrUpdateOQC', data);

// 获得OQC列表
export const getOQCList = (params) => request.get('api-qc/getOQCList', { params });

// 获得OQC合格情况
export const getOQCEligibility = (params) => request.get('api-qc/getOQCEligibility', { params });

// 获得IQC列表
export const getIQCList = (params) => request.get('api-qc/getIQCList', { params });

// IQC质检确认
export const IQCInspectionConfirm = (params) => request.get('/api-qc/IQCInspectionConfirm', { params });

export const IQCInspectionRollback = (params) => request.get('/api-qc/IQCInspectionRollback', { params });

// 添加或更新IQC
export const saveOrUpdateIQC = (data) => request.post('/api-qc/saveOrUpdateIQC', data);

// 添加或更新FQC
export const saveOrUpdateFQC = (data) => request.post('/api-qc/saveOrUpdateFQC', data);

// 获得FQC列表
export const getFQCList = (params) => request.get('api-qc/getFQCList', { params });

// 获得FQC合格情况
export const getFQCEligibility = (params) => request.get('api-qc/getFQCEligibility', { params });

// 合格率汇总
export const getEligibilitySummary = (params) => request.get('api-qc/getEligibilitySummary', { params });

// 获得意见反馈列表
export const getFeedbackList = (params) => request.get('/api-qc/getFeedbackList', { params });

// 添加或更新意见反馈
export const saveOrUpdateFeedback = (data) => request.post('/api-qc/saveOrUpdateFeedback', data);

// 删除PQ三大件
export const deletePQCThreeMajorItems = (data) => request.delete('/api-qc/deletePQCThreeMajorItems', { data });

// 删除PQC参考臂
export const deletePQCReferenceArm = (data) => request.delete('/api-qc/deletePQCReferenceArm', { data });

// 删除PQC完整参考臂
export const deletePQCCompleteReferenceArm = (data) => request.delete('/api-qc/deletePQCCompleteReferenceArm', { data });

// 删除PQC定标记录
export const deletePQCCalibrate = (data) => request.delete('/api-qc/deletePQCCalibrate', { data });

// 删除PQCPQC总装调试记录
export const deletePQCAssembleDebug = (data) => request.delete('/api-qc/deletePQCAssembleDebug', { data });

// 删除OQC记录
export const deleteOQC = (data) => request.delete('/api-qc/deleteOQC', { data });

// 删除IQC记录
export const deleteIQC = (data) => request.delete('/api-qc/deleteIQC', { data });

// 删除FQC记录
export const deleteFQC = (data) => request.delete('/api-qc/deleteFQC', { data });

// 清空备份文件
export const updateBackupFile = (id) => request.put(`/api-qc/updateBackupFile?id=${id}`);

// 获得备份文件列表
export const getBackupFileList = (params) => request.get('/api-qc/getBackupFileList', { params });

// 一次合格率数据
export const getFirstPassRateData = (params) => request.get('/api-qc/getFirstPassRateData', { params });
